import {zDateTime} from '@brunata-angular/util';
import {z} from 'zod';
import {ConsumptionAgentType} from './create-consumption-agent/consumption-agent-investigation/consumption-agent-investigation.model';
import {ConsumptionToMonitor} from './create-consumption-agent/consumption-agent-monitoring/consumption-agent-monitoring.model';

export const meterConsumptionSchema = z.object({
    meterId: z.number(),
    meterNo: z.string(),
    meterTypeNo: z.number(),
    mountingDate: zDateTime.nullable(),
    dismountedDate: zDateTime.nullable(),
    replacedBy: z.string().nullable(),
    alloUnitType: z.string().nullable(),
    unit: z.number(),
    meterGroupName: z.string(),
    propertyNo: z.string().nullable(),
    branchNo: z.string().nullable(),
    locationNo: z.string().nullable(),
    address: z.string().nullable(),
    placement: z.string().nullable(),
    monitoringConsumption: z.number().nullable(),
});
export type MeterConsumption = z.infer<typeof meterConsumptionSchema>;

export const percentageMeterConsumptionSchema = meterConsumptionSchema.extend({
    comparisonConsumption: z.number().nullable(),
    diff: z.number().nullable(),
    diffInPercentage: z.number().nullable(),
});

export type PercentageMeterConsumption = z.infer<typeof percentageMeterConsumptionSchema>;

export const periodSchema = z.object({
    startDate: zDateTime.nullable(),
    endDate: zDateTime.nullable(),
});

const consumptionAgentResultBaseSchema = z.object({
    monitoringPeriod: periodSchema,
    outputUnit: z.number().nullable(),
    showConsumptionForMeters: z.boolean().nullable(),
    isAgentCriteriaFulfilled: z.boolean().nullable(),
});

export const percentageConsumptionAgentResponseSchema = consumptionAgentResultBaseSchema.extend({
    comparisonPeriod: periodSchema,
    percentageMeterConsumptions: z.array(percentageMeterConsumptionSchema),
});

export const fixedValueConsumptionAgentResponseSchema = consumptionAgentResultBaseSchema.extend({
    meterConsumptions: z.array(meterConsumptionSchema),
    fixedValue: z.number().nullable(),
});

export const summedConsumptionAgentResponseSchema = fixedValueConsumptionAgentResponseSchema.extend(
    {
        comparisonConsumption: z.number().nullable(),
        diffInPercent: z.number().nullable(),
        summedComparisonConsumption: z.number().nullable(),
        summedMonitoringConsumption: z.number().nullable(),
        summedMonitoringConsumptionGroup1: z.number().nullable(),
        summedMonitoringConsumptionGroup2: z.number().nullable(),
    },
);
export const consumptionAgentResultSchema = z.object({
    ...percentageConsumptionAgentResponseSchema.partial().shape,
    ...fixedValueConsumptionAgentResponseSchema.partial().shape,
    ...summedConsumptionAgentResponseSchema.partial().shape,
    meterCriteriaMismatch: z.boolean(),
});

export type ConsumptionAgentResult = z.infer<typeof consumptionAgentResultSchema>;

export const CONSUMPTION_AGENT_RESULT_AGENT_TYPE_ENDPOINT: Record<ConsumptionAgentType, string> = {
    FIXED_VALUE: 'fixed',
    INCREASING_DECREASING: 'percentage',
    GROUP_COMPARISON: 'compare',
} as const;

export const CONSUMPTION_AGENT_RESULT_MONITOR_ENDPOINT: Record<ConsumptionToMonitor, string> = {
    INDIVIDUALCONSUMPTION: 'individual',
    SUMMEDCONSUMPTION: 'summed',
    DIFFERENCECONSUMPTION: 'twogroups',
} as const;
